import React from 'react';
import SelectFancy from '@atoms/SelectFancy';

const options = [
    { label: 'Male', value: 'M' },
    { label: 'Female', value: 'F' },
];

const EditProfileFieldsGender = () => (
    <>
        <SelectFancy label="Which of the following most accurately describe(s) you?" name="gender" options={options} />
    </>
);

export default EditProfileFieldsGender;
